import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

import {ViewTypeParam} from '../../api/view/contracts'
import {useViews} from '../../hooks/use-views'

type UseTableCopilotTasks = {
  /** Whether or not the table should show copilot tasks nested under parent items */
  copilotTasksEnabled: boolean
}

export const useTableCopilotTasks = (): UseTableCopilotTasks => {
  const projectsCopilotTasksStatus = useFeatureFlag('projects_copilot_tasks_status')
  const {currentView} = useViews()

  const enabled = projectsCopilotTasksStatus && currentView?.localViewState?.layout === ViewTypeParam.Table

  return {
    copilotTasksEnabled: enabled,
  }
}
